import omit from 'lodash/omit'
import React, {FC} from 'react'
import styled from '@mui/material/styles/styled'
import { CSSObject } from '@mui/material'
import { ComponentSelector, Keyframes, SerializedStyles, ArrayInterpolation, FunctionInterpolation } from '@mui/styled-engine'

type VersionProps = {
    number: string
}

export default function createVersionComponent(wrapper?: any, styles?: string | number | boolean | ComponentSelector | Keyframes | SerializedStyles | CSSObject | ArrayInterpolation<any> | FunctionInterpolation<any> | null | undefined) {
    const StyledVersion = styled(wrapper || 'label')(styles || versionDefaultStyles)
    const Version: FC<VersionProps> = (props) => {
        const forwarded = omit(props, ['number'])
        return <StyledVersion {...forwarded}>{props.number}</StyledVersion>
    }
    return Version
}


function versionDefaultStyles() {
    return {
      padding: 4,
      color:'#fff',
      fontFamily: 'mono',
      fontSize: '7.6pt',
      display: 'flex',
      justifyContent: 'center'
    }
}
